// ─── EN-TÊTE de groupe d'un ARBRE : la grammaire commune ──────────
// Décidée par Cédric le 15/08, après le démonstrateur : partout dans
// My Finance, un groupe d'arbre est une RANGÉE PLATE —
//   ▸/▾ à gauche (il plie) · emoji · nom · effectif · [donnée clé à droite]
// Les cartes blanches sont réservées aux FEUILLES (swipe + tap-fiche).
// L'en-tête SITUE, la carte INFORME.
//
// `onCorps` : geste propre au corps de la rangée (fiche du budget, ouvrir
// l'enveloppe…). Sans lui, tout le rang plie — pas de zone morte.
import React, { useMemo } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { useUI, useT } from '@mop/core';

const HIT = { top: 10, bottom: 10, left: 10, right: 10 };

export default function EnTeteArbre({
  plie, onBasculer, emoji, titre, nb, sousTitre, droite, onCorps,
  // Rien à plier (un mois sans opération rattachée) : le chevron laisse un
  // espace de sa largeur — l'alignement des rangées ne bouge pas.
  sansChevron = false,
}) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStyles(UI), [UI]);

  return (
    <View style={s.rang}>
      {sansChevron ? <View style={{ width: 14 }} /> : (
        <TouchableOpacity onPress={onBasculer} hitSlop={HIT}
          accessibilityLabel={t(plie ? 'commun.deplier' : 'commun.replier')}>
          <Text style={s.chev}>{plie ? '▸' : '▾'}</Text>
        </TouchableOpacity>
      )}
      <TouchableOpacity style={s.corps} activeOpacity={0.7}
        onPress={onCorps || onBasculer}>
        {!!emoji && <Text style={s.emoji}>{emoji}</Text>}
        <View style={{ flexShrink: 1, minWidth: 0 }}>
          <Text style={s.nom} numberOfLines={1}>{titre}</Text>
          {!!sousTitre && <Text style={s.sous} numberOfLines={1}>{sousTitre}</Text>}
        </View>
        {nb != null && <Text style={s.nb}>{nb}</Text>}
        <View style={{ flex: 1 }} />
        {/* La donnée clé de l'écran : un nœud déjà mis en forme — total
            signé, « réel / prévu (écart) »… L'en-tête ne calcule rien. */}
        {droite}
      </TouchableOpacity>
    </View>
  );
}

// Le retrait UNIFORME des feuilles sous un en-tête : le même partout, pour
// que la hiérarchie se lise d'un écran à l'autre.
export const RETRAIT_ENFANTS = 22;

const makeStyles = (UI) => StyleSheet.create({
  rang: { flexDirection: 'row', alignItems: 'center', gap: 8, paddingVertical: 9, paddingHorizontal: 4, marginTop: 6 },
  corps: { flex: 1, flexDirection: 'row', alignItems: 'center', gap: 8, minWidth: 0 },
  chev: { fontSize: 13, color: UI.accent, fontWeight: '800', width: 14 },
  emoji: { fontSize: 17 },
  nom: { fontSize: 14.5, fontWeight: '800', color: UI.ink },
  sous: { fontSize: 11.5, color: UI.muted, marginTop: 1, fontWeight: '600' },
  nb: { fontSize: 12, color: UI.faint, fontWeight: '700' },
});
